import React, { useState } from 'react';
import DailyReconciliationTable from './components/DailyReconciliationTable';
import SubHeader from './components/SubHeader';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { Container } from 'components/BookingMain/styles';

const DailyReconciliationReport = () => {

  const [checkInDate, setCheckInDate] = useState(moment().tz(TIME_ZONE));
  const [checkOutDate, setCheckOutDate] = useState(moment().tz(TIME_ZONE).add(1, 'days'));
  const [dataTypeOption, setDataTypeOption] = useState("TRANSACTION_DATE")
  const [reports, setReports] = useState([])

  return (
    <>
      <SubHeader
        checkInDate={checkInDate}
        setCheckInDate={setCheckInDate}
        checkOutDate={checkOutDate}
        setCheckOutDate={setCheckOutDate}
        dataTypeOption={dataTypeOption}
        setDataTypeOption={setDataTypeOption}
        setReports={setReports}
      />
      <Container>
        <DailyReconciliationTable
          reports={reports}
        />
      </Container>
    </>
  );
};

export default DailyReconciliationReport;
